import React from 'react';
import { EngagementFunnel } from '../types';
import { pct } from '../lib';
import NumberStrip, { StripItem } from './NumberStrip';

/** Numbers-only engagement funnel — people → opened → viewed → brochure →
 *  tapped. Likes and shares stay per row in the table. */
const EngagementFunnelStrip: React.FC<{ funnel: EngagementFunnel }> = ({ funnel }) => {
  const items: StripItem[] = [
    // Distinct people: a lead once, an anonymous visitor once.
    { v: funnel.leads, k: 'people' },
    { v: funnel.opened, k: 'opened', p: pct(funnel.opened, funnel.leads) },
    { v: funnel.viewed_frames, k: 'viewed frames', p: pct(funnel.viewed_frames, funnel.leads) },
    { v: funnel.brochure, k: 'brochure', p: pct(funnel.brochure, funnel.leads) },
    { v: funnel.cta_clicked, k: 'tapped a button', p: pct(funnel.cta_clicked, funnel.leads), cls: 'visited' },
    ...(funnel.submitted > 0 ? [{ v: funnel.submitted, k: 'submitted' }] : []),
  ];
  return <NumberStrip items={items} />;
};

export default EngagementFunnelStrip;
